import { css } from 'emotion'

export const WorkspaceStorageUploadFieldStyles = css`
  .clickableContainer {
    position: relative;
    display: flex;
    overflow: hidden;
    cursor: pointer;

    input {
      opacity: 0;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      cursor: pointer;
    }
  }

  .ErrorMessage {
    margin: 4px;
  }
`
